import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { LORAX, LORAX_LIGHT } from 'HubStyleTokens/colors';
import { H6 } from 'UIComponents/elements/headings';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { useAppRelatedInstallStats } from '../../../utils/hooks/useAppRelatedInstallStats';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledAppRelatedInstallStatsTitleWrapper = styled(UITileSection).withConfig({
  displayName: "AppRelatedInstallStatsSection__StyledAppRelatedInstallStatsTitleWrapper",
  componentId: "sc-1rmuoeb-0"
})(["display:flex;"]);
const StyledAppRelatedInstallStatsTile = styled(UITile).withConfig({
  displayName: "AppRelatedInstallStatsSection__StyledAppRelatedInstallStatsTile",
  componentId: "sc-1rmuoeb-1"
})(["background-color:", ";border-color:", ";padding:8px 0;> *{padding:8px 8px 8px 20px;display:flex;}h6{line-height:1;padding:4px;}ul{padding-left:20px;}"], LORAX_LIGHT, LORAX);
export const AppRelatedInstallStatsSection = ({
  offeringId
}) => {
  const appRelatedInstallStats = useAppRelatedInstallStats(offeringId);
  const hasAppRelatedInstallStats = appRelatedInstallStats.country || appRelatedInstallStats.industry || appRelatedInstallStats.plan;
  return hasAppRelatedInstallStats && /*#__PURE__*/_jsx("div", {
    "data-test-id": "app-related-install-stats-section",
    children: /*#__PURE__*/_jsxs(StyledAppRelatedInstallStatsTile, {
      compact: true,
      "data-test-id": "app-related-install-stats-title",
      children: [/*#__PURE__*/_jsxs(StyledAppRelatedInstallStatsTitleWrapper, {
        children: [/*#__PURE__*/_jsx(UIIcon, {
          className: "p-right-2",
          style: {
            margin: 'auto 0',
            paddingTop: '2px'
          } // it just needed the smallest adjustment
          ,
          color: LORAX,
          name: "highlyEngagedLead",
          size: "xs"
        }), /*#__PURE__*/_jsx(H6, {
          children: /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "appMarketplace.detail.overview.sidebar.appRelatedInstallStats.title"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(UITileSection, {
        children: /*#__PURE__*/_jsx(UIList, {
          styled: true,
          childClassName: "m-y-1",
          firstChildClassName: "",
          lastChildClassName: "",
          children: Object.keys(appRelatedInstallStats).map(stat => {
            const statKey = stat; // have to force the type here
            if (!appRelatedInstallStats[statKey]) {
              return null;
            }
            const count = Object.values(appRelatedInstallStats[statKey])[0] || 0;
            const value = Object.keys(appRelatedInstallStats[statKey])[0];
            return /*#__PURE__*/_jsx("span", {
              "data-test-id": `app-related-install-stats-${stat}-stat`,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `appMarketplace.detail.overview.sidebar.appRelatedInstallStats.${statKey}`,
                options: {
                  count: I18n.formatNumber(Math.floor(count / 10) * 10),
                  value
                }
              })
            }, stat);
          })
        })
      })]
    })
  });
};